// extracted by mini-css-extract-plugin
export default {"container":"style_container__LQHpF","box":"style_box__Kfro3","valuesWrapper":"style_valuesWrapper__ptY9H"};